import { useMemo } from 'react'
import { TileSectionIds } from '@dataplace.ai/constants'
import { ISectionTile } from 'apps/placeme/src/features/Analyse/slice/@types/ISectionTile'
import useGetLayers from './useGetLayers'
import { WellFitCompetitionWithinRangeProps } from '../WellFitCompetitionWithinRange'

interface UseWEllFitCompetitionWithinRangeProps {
  values: ISectionTile[]
  tileId: string
  data: WellFitCompetitionWithinRangeProps
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function useWellFitCompetitionWithinRange({
  values,
  tileId,
  data,
}: UseWEllFitCompetitionWithinRangeProps) {
  const own = useMemo(() => data?.value?.competition?.own, [data])
  const competitors = useMemo(() => data?.value?.competition?.competitors, [data])

  const tile = useMemo(() => {
    const found = values?.find(cat => cat.id === TileSectionIds.WELL_FIT)?.tiles?.find(t => t.id === tileId)
    if (!found) {
      throw new Error(`Missing tileId in tiles: ${tileId}`)
    }
    return found
  }, [values, tileId])

  const catchmentId = useMemo(() => tile?.chosenRange?.catchmentId, [tile])
  const layers = useGetLayers(data, tile)

  return {
    catchmentId,
    layers,
    own,
    competitors,
  }
}

export default useWellFitCompetitionWithinRange
